import React from 'react';
import { Spinner } from 'reactstrap';

export default class SpanSpinner extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            message: props.message || 'Processing...'
        }
    }

  render() {
    return (
        <span>
            <Spinner size="sm" color="secondary" />
            <span className="ml-2">{this.state.message}</span>
        </span>
    );
  }
}